export const MODAL_STRINGS = {
  STOPPED: 'The round has ended. Please wait for the next round to begin.',
  END_GAME: 'Congrats on a life well-lived!',
  END_TEXT: 'Discover how to better design your career here:',
  OK: 'OK',
};
